import { render, staticRenderFns } from "./footPage.vue?vue&type=template&id=4c8fcb1c&scoped=true"
import script from "./footPage.vue?vue&type=script&lang=js"
export * from "./footPage.vue?vue&type=script&lang=js"
import style0 from "./footPage.vue?vue&type=style&index=0&id=4c8fcb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fcb1c",
  null
  
)

export default component.exports